<template>
	<div class="header-user">
		<div class="header-user__text">
			<a href="/personal/"  class="header-user__link"></a>
			<span class="header-user__name">{{ userData?.name }} {{ userData?.lastName }}</span>
			<span class="header-user__position" v-if="userData?.description">{{userData?.description}}</span>
			<span class="header-user__btns">
				<a href="/personal/" class="btn btn--color"> Личный кабинет </a>
				<span class="btn btn--border" @click="logoutUser"> Выйти </span>
			</span>
		</div>
		<div class="header-user__menu">
			<div class="hu-menu">
				<a href="/personal/" class="hu-menu__item personal">Личный кабинет</a>
				<a class="hu-menu__item logout" @click="logoutUser">Выйти из аккаунта</a>
			</div>
		</div>

	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
	name: "UserInfo",
	props: {
		notices: {
			type: Number,
			default: 0
		}
	},
	async created() {
		if(this.notices) {
			this.setUserNotice(this.notices)
		}
		await this.requestUserData()
	},

	methods: {
		async logoutUser() {
			let response = await this.requestLogoutUser()

			if(response.success) {
				window.location.href = '/'
			}
		},
		...mapActions({
			requestUserData: 'user/requestUserData',
			requestLogoutUser: 'user/requestLogoutUser',
		}),
		...mapMutations({
			setUserNotice: 'user/setUserNotice',
		}),
	},
	computed: {
		...mapGetters({
			userData: 'user/getUserData',
		})
	},
}
</script>
